<template>
    <div class="bg-neutral-950">
        <NewHeader></NewHeader>
        <ColorBg>
            <div id="banner-top" class="relative mx-auto max-w-7xl px-6 pb-16 pt-40 sm:py-40 lg:px-8">
                <div
                    class="relative z-40 mx-auto max-w-2xl lg:mx-0 lg:grid lg:max-w-none lg:grid-cols-2 lg:gap-x-16 lg:gap-y-6 xl:grid-cols-1 xl:grid-rows-1 xl:gap-x-8 items-center">
                    <div class="mt-6 max-w-xl lg:mt-0 xl:col-end-1 xl:row-start-1">
                        <h1
                            class="font-extrabold text-5xl leading-[1.2] text-gray-200 mb-7 max-[450px]:text-3xl max-[450px]:text-center">
                            {{ t('pages.faceSwapPhoto.title_prefix') }}
                            <span class="text-orange-600">{{ t('pages.faceSwapPhoto.brand_name') }}</span>
                            {{ t('pages.faceSwapPhoto.title_suffix') }}
                        </h1>
                        <p class="text-base font-normal text-white/50 mb-7 max-[450px]:text-center">
                            {{ t('pages.faceSwapPhoto.description') }}
                        </p>
                        <div class="flex flex-col min-[450px]:flex-row items-center gap-5">
                            <FaceSwapBtn />
                        </div>
                    </div>
                    <img src="/idx/png_photo_faceswap_header_img.png" alt="" class="w-full rounded-3xl pt-12 lg:pt-0">

                </div>
            </div>
        </ColorBg>
        <FaceSwapPhoTemp></FaceSwapPhoTemp>
        <Explore></Explore>
        <Testimonial :items="items"></Testimonial>
        <Cta></Cta>
        <NewFooter></NewFooter>
    </div>
</template>
<script setup lang="ts">
import Cta from '~/components/Cta.vue';
import Testimonial from '~/components/Testimonial.vue';
import NewHeader from '~/components/NewHeader.vue';
import FaceSwapPhoTemp from '~/components/FaceSwapPhoTemp.vue';
import Explore from '~/components/Explore.vue';
import FaceSwapBtn from '~/components/FaceSwapBtn.vue';
import NewFooter from '~/components/NewFooter.vue';
import ColorBg from '~/components/ColorBg.vue';

const { t } = useI18n();

useHead({
    title: t('seo.faceSwapPhoto.title'),
    meta: [
        {
            name: 'description',
            content: t('seo.faceSwapPhoto.description')
        }
    ],
});

const items = [
    {
        avatar: '/idx/avater_01.png',
        name: t('pages.faceSwapPhoto.testimonials.person1.name'),
        content: t('pages.faceSwapPhoto.testimonials.person1.content')
    },
    {
        avatar: '/idx/avater_02.png',
        name: t('pages.faceSwapPhoto.testimonials.person2.name'),
        content: t('pages.faceSwapPhoto.testimonials.person2.content')
    },
    {
        avatar: '/idx/avater_03.png',
        name: t('pages.faceSwapPhoto.testimonials.person3.name'),
        content: t('pages.faceSwapPhoto.testimonials.person3.content')
    },
    {
        avatar: '/idx/avater_04.png',
        name: t('pages.faceSwapPhoto.testimonials.person4.name'),
        content: t('pages.faceSwapPhoto.testimonials.person4.content')
    },
    {
        avatar: '/idx/avater_05.png',
        name: t('pages.faceSwapPhoto.testimonials.person5.name'),
        content: t('pages.faceSwapPhoto.testimonials.person5.content')
    },
    {
        avatar: '/idx/avater_06.png',
        name: t('pages.faceSwapPhoto.testimonials.person6.name'),
        content: t('pages.faceSwapPhoto.testimonials.person6.content')
    }
];

</script>